import RowDetails from './rowDetails'
export default RowDetails
